export const oldTenantList = [
  {
    id: 1,
    class: "REBRAND_2024",
    body: "REBRAND_2024_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 7,
    class: "palette-2020",
    body: "palette20",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 12,
    class: "version_2_2020|sa-co-brand-2020|agnostic-body",
    body: "body-background-v2|body-sa-co-brand-2020|agnostic-body",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 17,
    class: "REBRAND_2024",
    body: "REBRAND_2024_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 18,
    class: "REBRAND_2021",
    body: "REBRAND_2021_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 19,
    class: "VERSION_2",
    body: "report-panel",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 26,
    class: "updates_2021",
    body: "palette_2021",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 27,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 28,
    class: "REBRAND_2022",
    body: "REBRAND_2022_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 31,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 33,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 34,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 35,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 36,
    class: "REBRAND_2024",
    body: "REBRAND_2024_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 38,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 42,
    class: "cms",
    body: "bdy-cms",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 45,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 46,
    class: "REBRAND_2022",
    body: "REBRAND_2022_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 47,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 48,
    class: "REBRAND_2021",
    body: "REBRAND_2021_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 50,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 51,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 52,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 53,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 54,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 55,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 58,
    class: "REBRAND_2022",
    body: "REBRAND_2022_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 59,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 61,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 63,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 65,
    class: "REBRAND_2023",
    body: "REBRAND_2023_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 66,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 67,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 68,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 69,
    class: "REBRAND_2024",
    body: "REBRAND_2024_BODY",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 71,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 72,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 74,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 76,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 77,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 78,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 79,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 80,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 81,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 82,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 83,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 84,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 85,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 86,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 87,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 88,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 89,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 90,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 91,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 92,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 93,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 94,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 95,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 96,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 97,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 98,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 99,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 100,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 101,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 102,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
  {
    id: 103,
    class: "",
    body: "",
    place: "INTERACTION_PARENT_NEW",
  },
];
